module.exports = __webpack_public_path__ + "files/33d930ef0a4648142dcbecd5169b68f3.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-4.png
// module id = 528
// module chunks = 76